import { render, staticRenderFns } from "./zDrugPage.vue?vue&type=template&id=0d0c159e&scoped=true"
import script from "./zDrugPage.vue?vue&type=script&lang=js"
export * from "./zDrugPage.vue?vue&type=script&lang=js"
import style0 from "./zDrugPage.vue?vue&type=style&index=0&id=0d0c159e&prod&scoped=true&lang=css"
import style1 from "./zDrugPage.vue?vue&type=style&index=1&id=0d0c159e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c159e",
  null
  
)

export default component.exports